module.exports = __webpack_public_path__ + "static/media/autoDoor3.8903e374.png";